import React, { useContext } from 'react';
import classnames from 'classnames';

import './Text.scss';

export interface TextProps {
    /**
     * Tag
     */
    tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'p' | 'span' | 'label' | 'small';
    /**
     * Typo
     */
    typo?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'p' | 'span' | 'label' | 'xxl' | 'xl' | 'small' | 'small-xs';
    /**
     * For attr label tag
     */
    for?: string;
    /**
     * Color style icon
     */
    color?:
        | 'primary'
        | 'secondary'
        | 'tertiary'
        | 'accent'
        | 'white'
        | 'black'
        | 'success'
        | 'warning'
        | 'error'
        | 'gray-light'
        | 'gray'
        | 'gray-dark'
        | 'gradient'
        | 'gradient-reverse'
        | 'gradient-1'
        | 'gradient-1-reverse'
        | 'gradient-2'
        | 'gradient-2-reverse'
        | 'gradient-3'
        | 'gradient-3-reverse'
        | 'gradient-4'
        | 'gradient-4-reverse'
        | 'gradient-secondary';
    /**
     * Weight font of text
     */
    weight?: 'light' | 'medium' | 'semi' | 'bold';
    /**
     * Align text
     */
    align?: 'left' | 'center' | 'right';
    /**
     * Icon size
     */
    size?: string | number;
    /**
     * Icon scale size
     */
    scale?: string | number;
    /**
     * Persist default style
     */
    persist?: boolean;
    /**
     * Capitalize
     */
    capitalize?: boolean;
    /**
     * Uppercase
     */
    uppercase?: boolean;
    /**
     * Underline
     */
    underline?: boolean;
    /**
     * Italic
     */
    italic?: boolean;
    /**
     * Ellipsis
     */
    ellipsis?: boolean;
    /**
     * Class name styles
     */
    className?: string;
    /**
     * Style
     */
    style?: any;
    /**
     * Slot component
     */
    children?: React.ReactNode;
    /**
     * Other props
     */
    [otherProps: string]: any;
}

const Text: React.FC<TextProps> = ({
    tag: Tag = 'p',
    typo = 'p',
    size,
    scale,
    color,
    weight,
    align,
    persist = false,
    capitalize = false,
    uppercase = false,
    underline = false,
    italic = false,
    ellipsis = false,
    className,
    style = {},
    children,
    for: htmlFor,
    ...otherProps
}) => {
    const classNames = classnames([
        'text',
        typo,
        color,
        weight,
        align,
        size ? `fs${size}` : '',
        {
            capitalize,
            uppercase,
            underline,
            italic,
            ellipsis,
        },
        className,
    ]);
    const styles = {
        ...(style || {}),
        ...(scale ? { fontSize: `${scale}rem`, lineHeight: `${scale}rem` } : {}),
    };

    return (
        <Tag className={classNames} style={styles} htmlFor={htmlFor} {...otherProps}>
            {children}
        </Tag>
    );
};

export default Text;
